import styled from "styled-components";

import { withSWReactIconFillColor } from "../../../styles";

export const StyledTabWithCounter = styled.div`
    align-items: center;
    display: flex;
`;

export const StyledTabWithCounterIconWrap = styled.div<{ withIconFill: boolean }>`
    margin-right: 12px;

    ${({ withIconFill }) => withIconFill && withSWReactIconFillColor("currentColor")};
`;

export const StyledTabWithCounterNumberOfResults = styled.div`
    align-items: center;
    display: flex;
    gap: 4px;

    & span.thin {
        font-weight: 400;
        text-transform: lowercase;
    }
`;
